let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eUKfO")).then(() => parcelRequire('45iy5'));